import Grid from "./Grid";
import { useSelector } from "react-redux";
import { selectMetadata, selectPages } from "../redux/reportSlice";
import ReportPage from "./ReportPage";

function GridReport() {
  const metadata = useSelector(selectMetadata);
  const pages = useSelector(selectPages);

  return (
    <div title="Report">
      {pages === null ? null : pages.length ? (
        pages.map((d, idx) => {
          return (
            <ReportPage
              key={idx}
              pageNumber={idx + 1}
              totalPages={pages.length}
            >
              <Grid data={d} metadata={metadata} />
            </ReportPage>
          );
        })
      ) : (
        <ReportPage key={1} pageNumber={1} totalPages={1}>
          <Grid data={null} metadata={metadata} />
          <div className="no-record-found-msg">
            No records found for the selected criteria
          </div>
        </ReportPage>
      )}
    </div>
  );
}
export default GridReport;
